import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useProtectedRoute } from "../../hooks/useAuth";
import {
  Box,
  CircularProgress,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, shouldRedirect } = useProtectedRoute();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (shouldRedirect) {
      navigate("/login");
    }
  }, [shouldRedirect, navigate]);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: { xs: 2, sm: 3 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <CircularProgress
            size={isMobile ? 60 : 80}
            sx={{ color: "rgba(24, 116, 210, 1)" }}
          />
          <Typography
            variant="body1"
            sx={{
              color: "#666",
              fontSize: { xs: "0.9rem", sm: "1rem" },
            }}
          >
            Loading...
          </Typography>
        </Box>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          flexDirection: "column",
          padding: { xs: 2, sm: 3 },
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          component="h2"
          sx={{
            marginBottom: { xs: 1.5, sm: 2 },
            fontWeight: 700,
            fontSize: { xs: "1.5rem", sm: "2rem", md: "2.25rem" },
            color: "#061c36",
          }}
        >
          Authentication Required
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#666",
            fontSize: { xs: "0.9rem", sm: "1rem" },
            maxWidth: { xs: "100%", sm: "500px" },
          }}
        >
          Redirecting to login page...
        </Typography>
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;
